import React,{useState,useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import {currentRouteSet} from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'; 
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import {pathSpliter,dateTimeFormat,currentDateTime,getDateTimeFromISODT,currentDateStartTime,currentDateEndTime} from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import {API_URL} from '../../config.json';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import _ from 'lodash';
import PrintIcon from '@material-ui/icons/Print';
import Select from 'react-select';
import '../commons/commons.css'


import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import  InstitutionProfile from '../commons/institution_profile'
import ReactToPrint from "react-to-print";
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')
const CashTransactionHistory = ({location,currentRoute,currentRouteSet,authInfo})=>{
  const classes = useStyles();
  useEffect(()=>{
      currentRouteSet(pathSpliter(location.pathname,1));
  },[]);
  let [materials,materialsSet] = useState([]);
  let [selectedMaterial,selectedMaterialSet] = useState(null);
  let [report,reportSet] = useState([]);
  let [print,printSet] = useState(false);
  let [reportLoading,reportLoadingSet] = useState(false);

  let [opening_stock,opening_stock_set] = useState(0);
  let [closing_stock,closing_stock_set] = useState(0);
  let [sumReadyForDispatch, setSumReadyForDispatch] = useState([])
  let [sumDispatched, setSumDispatched] = useState([])
  let [uniquePrd, setUniquePrd] = useState([])


  let [byDateTime,byDateTimeSet] = useState({
        fromDate: currentDateStartTime(),
        toDate:currentDateEndTime()
  })

  let customerRef = useRef(null);
  let fromDateRef = useRef(null);
  let reportRef = useRef(null);

  const calculateSum = () => {
    const ready = {};
    const sold = {};
    report.forEach(ele => {
      ready[ele.prod_id] = 0;
      sold[ele.prod_id] = 0;
    });

    report.forEach(ele => {
      ready[ele.prod_id] += ele.ready_for_dispatch_qty;
      sold[ele.prod_id] += ele.dispatched_qty;
    });
    
    setSumReadyForDispatch(ready);
    setSumDispatched(sold);
    console.log(uniquePrd)
    // setUniquePrd([...new Set(report.map(item => JSON.stringify({id: item.prod_id, name: item.prod_name})))].map(str => JSON.parse(str)));
    // console.log(uniquePrd)
  }
  

  useEffect(()=>{ 
    getMaterials();
  },[]);

  useEffect(()=>{
    calculateSum();
  },[report]);

  // useEffect(()=>{
  //   console.log(uniquePrd)
  // },[uniquePrd])

  let getMaterials = async ()=>{
    await axios.post(`${API_URL}/api/get-materials`,null,{headers:{'auth-token':authInfo.token}}).then(res=>{
          materialsSet(res.data.message)
    })
  }
 
   

  let getSearchResult = async ()=>{

        if(selectedMaterial == null){
            swal({title:'Select Material',icon:'warning'}); return false;
        }

      let payload = {
          materialId: selectedMaterial != null? selectedMaterial.material_id:null,
          fromDate: byDateTime.fromDate,
          toDate: byDateTime.toDate
      }

     
      reportLoadingSet(true)
      await axios.post(`${API_URL}/api/get-material-ledger`,{...payload},{headers:{'auth-token':authInfo.token}}).then(res=>{
        reportSet(res.data.ledger)
        opening_stock_set(res.data.opening_stock)
        closing_stock_set(res.data.closing_stock)
        const uniqueProducts = [...new Set(res.data.ledger.map(item => JSON.stringify({id: item.prod_id, name: item.prod_name})))].map(str => JSON.parse(str))
        setUniquePrd(uniqueProducts)
        console.log(uniqueProducts, uniquePrd, report)
        printSet(true)
        reportLoadingSet(false)
  })

  }


  let ReportDom = React.forwardRef((props,ref)=>{
      return(
      
      <div ref={ref}>
        <InstitutionProfile />

        <div style={{clear:'both'}}></div>
<Paper style={{width:'100%',paddingLeft:'10px',paddingRight:'10px'}} className="print-source">
<p style={{width:'100%',textAlign:'center',fontWeight:'bold'}}>Material Ledger </p>

  <p style={{float:'left',width:'30%',textAlign:'left',margin:0,padding:0,fontSize:'16px'}}>
    {selectedMaterial != null ?`Material Name : ${selectedMaterial!=null?selectedMaterial.material_name:''}`:''}
    </p>

<p style={{float:'right',width:'40%',textAlign:'right',margin:0,padding:0}}> Statement From { moment(byDateTime.fromDate).format(dateTimeFormat)  } <br/> TO { moment(byDateTime.toDate).format(dateTimeFormat) }
</p>
</Paper> 


               {
     report.length>0?(
      <Paper className={classes.paper} style={{marginTop:'8px',marginBottom:'5px'}} >
  

      <TableContainer >
        <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
          <TableHead>
            <TableRow> 
              <TableCell align="left" style={{width:'1%'}}>SL</TableCell>
              <TableCell align="left" style={{width:'10%'}}>Date </TableCell>
              <TableCell align="left" style={{width:'15%'}}>Description</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Purchase Stock</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Fault Stock</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Rejected Stock</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Ready for dispatch</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Dispatched Stock</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Remaining for Dispatch Stock</TableCell>
              <TableCell align="left" style={{width:'15%'}}>Rate</TableCell>
              
              <TableCell align="right" style={{width:'15%'}}>Stock</TableCell>
             
            </TableRow>
          </TableHead>
          <TableBody>


          <TableRow  key=""> 
                    <TableCell colSpan={2}  align="right"></TableCell>
                    <TableCell style={{color: '#005400',fontWeight:'bold'}}>Opening Stock -> </TableCell>
                    <TableCell colSpan={7} align="right"> </TableCell>
                  <TableCell style={{color: '#005400',fontWeight:'bold'}} align="left">{ format(parseFloat(opening_stock).toFixed(2))}</TableCell>
          </TableRow>
              
              {
                report.map((row,sl)=>(
                    <TableRow  key=""> 
                    <TableCell>{sl+parseFloat(1)}.</TableCell>
                  <TableCell  align="left">{moment(row.dateTime).format('Y MMM DD')}</TableCell>
                
                  <TableCell  align="left">{row.description}</TableCell>
                  <TableCell  align="left">{format(parseFloat(row.in_qty).toFixed(2))}</TableCell>
                  <TableCell  align="left">{format(parseFloat(row.material_fault_qty).toFixed(2))}</TableCell>
                  <TableCell  align="left">{format(parseFloat(row.material_rejected_qty).toFixed(2))}</TableCell>
                  <TableCell  align="left">{row.prod_name} = {format(parseFloat(row.ready_for_dispatch_qty).toFixed(2))}</TableCell>
                  <TableCell  align="left">{row.prod_name} = {format(parseFloat(row.dispatched_qty).toFixed(2))}</TableCell>
                  <TableCell  align="left">{row.prod_name} = {format(parseFloat(row.remaining_ready_for_dispatch).toFixed(2))}</TableCell>
                  <TableCell  align="left">{row.rate}</TableCell>
                  <TableCell  align="right">{format(parseFloat(row.stock).toFixed(2))}</TableCell>
                   </TableRow>
                ))
                   
        
              }

                  <TableRow style={{background: '#f1f1f1'}}> 
                    <TableCell colSpan={3}  align="right">Total (IN & Out) : </TableCell>
                    <TableCell  align="left">{format(report.reduce((prev,curr)=>{ return prev + curr.in_qty},0).toFixed(2))}</TableCell>
                    <TableCell  align="left">{format(report.reduce((prev,curr)=>{ return prev + curr.material_fault_qty},0).toFixed(2))}</TableCell>
                    <TableCell  align="left">{format(report.reduce((prev,curr)=>{ return prev + curr.material_rejected_qty},0).toFixed(2))}</TableCell>
                    <TableCell  align="left">{format(report.reduce((prev,curr)=>{ return prev + curr.ready_for_dispatch_qty},0).toFixed(2))}</TableCell>
                    <TableCell  align="left">{format(report.reduce((prev,curr)=>{ return prev + curr.dispatched_qty},0).toFixed(2))}</TableCell>
                    <TableCell  align="left">{format(report.reduce((prev,curr)=>{ return  0 + curr.remaining_ready_for_dispatch},0))}</TableCell>
                    
                    <TableCell  align="left" colSpan={1}></TableCell>
                   </TableRow>
         

         <TableRow  key="" >  
                    <TableCell colSpan={5}  align="right"></TableCell>
                    <TableCell colSpan={5} align="right" style={{color: '#005400',fontWeight:'bold'}} >Closing  Stock -> </TableCell>
                    <TableCell  style={{color: '#005400',fontWeight:'bold'}}  align="left">{ format(parseFloat(closing_stock).toFixed(2))}</TableCell>
        </TableRow>
 
 
        {
          
          uniquePrd.map((row, idx) => (
             row.id > 0 && <TableRow key={row.id}>
              <TableCell colSpan={6}  align="right"></TableCell>
            <TableCell  key = {row.id} >{row.name} = {sumReadyForDispatch[row.id]}</TableCell>
            <TableCell key = {row.id} >{row.name} = {sumDispatched[row.id]}</TableCell>
            <TableCell key = {row.id} >{row.name} = {parseFloat(sumReadyForDispatch[row.id])-parseFloat(sumDispatched[row.id])}</TableCell>
            </TableRow>
          ))
        }
         
 
                  
            
    
       
         
    
    
          </TableBody>
        </Table>
      </TableContainer>
          </Paper>
     ):''
  }
      </div>)
  })

    return(
        <div className={classes.root}> 
<Paper className={classes.paper} style={{marginTop:'-25px',marginBottom:'5px'}}>
<h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
  marginBottom: '2px'}}>Material Ledger</h4> 
  
  

<Grid container spacing={3} > 
     
        <Grid item  xs={12}   sm={2} > 
        <Autocomplete 
        size="small"

        autoHighlight
            openOnFocus={true}
            style={{width:'100%',height:'20px'}}
            options={materials}
            value={selectedMaterial}
            getOptionLabel={(option) => option.material_name}
            onChange={(event,selectedObj)=>{
               selectedMaterialSet(selectedObj)
            }}
            inputRef={customerRef}

            onKeyDown={event => {
                if (event.key === "Enter") {
                    fromDateRef.current.focus()
                }
              }}

            renderInput={(params) => <TextField 
               
              {...params} 
              label="Material " 
              variant="outlined"
              />} 
        />
        </Grid>
        
        <Grid item  xs={12}  sm={2} style={{marginBottom: '-9px'}} > 
          <MuiPickersUtilsProvider  utils={DateFnsUtils} > 
        
          <KeyboardDateTimePicker
        //  inputRef={saleDateRef}
          onKeyDown={(e)=>{
            if(e.key==='Enter'){
              //supplierRef.current.focus()
            }
          }}
          style={{ width: '100%',marginTop: '' }}
          value={byDateTime.fromDate}
          onChange={(datet)=>{
            byDateTimeSet({...byDateTime,fromDate:datet})
          }}
          label="From Date &   Time"
          format="Y/MM/d hh:mm a"
          /> 
          </MuiPickersUtilsProvider>
        </Grid>


        <Grid item  xs={12}  sm={2} style={{marginBottom: '-9px'}} > 
          <MuiPickersUtilsProvider  utils={DateFnsUtils} > 
        
          <KeyboardDateTimePicker
          //inputRef={saleDateRef}
          onKeyDown={(e)=>{
            if(e.key==='Enter'){
             // supplierRef.current.focus()
            }
          }}
          style={{ width: '100%',marginTop: '' }}
          value={byDateTime.toDate}
          onChange={(datet)=>{
            byDateTimeSet({...byDateTime,toDate:datet})

          }}
          label="To Date &   Time"
          format="yyyy/MM/dd hh:mm a"
             />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item  xs={12}   sm={1} >
      <Button style={{marginTop: '5px',marginLeft: 'auto',fontSize:'14px'}} 
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          startIcon={<SearchIcon/>}
                          onClick={getSearchResult}
                          disabled={reportLoading?true:false}
                      >
                     Search 
                    </Button>
      </Grid>

      </Grid> 
      </Paper> 

      {
          print?(
            <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{borderRadius:'0px',marginTop: '-7px'}}>
              <ReactToPrint
                          trigger={() => <PrintIcon  style={{cursor:'pointer',marginLeft: '30px',marginTop: '3px',marginBottom: '-8px'}} />}
                          content={() => reportRef.current}
                        />
              </Paper>
           
            </Grid>
        </Grid>
          ):''
        }

            <ReportDom ref={reportRef} />
</div>

    )
}
const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    inputField:{
      width:'100%',
      marginTop:'5px'
    },
    plusLinkDiv:{
      position:'relative'  
    },
    plusLink:{
      margin: 0,
      padding: 0,
      marginTop: '-21px',
      fontSize: '29px',
      height: '21px',
      textAlign: 'right',
      position: 'absolute',
      right: 0,
      color: '#3e8d54'
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));


const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(CashTransactionHistory);